<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingPaymentMethods"
  >
    <h3>{{ $t('mEditionBillingPaymentMethods.title.first') }}</h3>
    <div class="m-list-integrations m-list-integrations-separate">
      <article
        v-for="pasarela in pasarelas"
        :key="pasarela.id"
        class="m-card-primary m-card-transition m-list-integrations-item"
        @click.prevent="selectPasarela(pasarela)"
      >
        <div class="m-list-integrations-item-actions m-list-integrations-item-actions-billing">
          <span>{{ $t('mEditionBillingPaymentMethods.action') }}</span>
        </div>
        <img
          alt="pasarela.nombre"
          :src="pasarela.imagen ? pasarela.imagen : '@/assets/img/payment.png'"
        >
        <h5>{{ pasarela.nombre }}</h5>
      </article>
    </div>

    <h3 v-if="academiaPasarelasConfiguradas.length">
      {{ $t('mEditionBillingPaymentMethods.title.second') }}
    </h3>
    <div
      v-if="academiaPasarelasConfiguradas.length"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionBillingPaymentMethods.table.thName') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingPaymentMethods.table.thMethod') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingPaymentMethods.table.thEdit') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingPaymentMethods.table.thActive') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingPaymentMethods.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="pasarela in academiaPasarelasConfiguradas"
          :key="pasarela.id"
          class="row-data"
        >
          <td class="display-flex-row-center text-align-left">
            <img
              alt="pasarela.nombre"
              class="border-radius-medium margin-right-small width-60-px"
              :src="pasarela.imagen ? pasarela.imagen : '@/assets/img/payment.png'"
            >
            {{ pasarela.descripcion }}
          </td>
          <td class="text-align-center">
            {{ getPasarelaNombre(pasarela.pasarela_pago) }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="pasarela"
              @editPasarela="editPasarela(pasarela)"
            />
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="pasarela.activa"
              :disabled="requests.updateAcademiaPasarelaEstado.isRequested"
              :element-id="pasarela.id_academia_pasarela_pago"
              method="updateAcademiaPasarelaEstado"
              name="activa"
              :show-loading="requests.updateAcademiaPasarelaEstado.isRequested &&
                requests.updateAcademiaPasarelaEstado.itemLoading === pasarela.id_academia_pasarela_pago"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updateAcademiaPasarelaEstado="updateAcademiaPasarelaEstado"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="pasarela.id_academia_pasarela_pago"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>

</template>

<script>
export default {
  name: 'MoleculeEditionBillingPaymentMethods',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaId: '',
      academiaPasarelasConfiguradas: [],

      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionBillingPaymentMethodsModalDelete',
          icon: 'fas fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionBillingPaymentMethods.tooltip.delete'),
          type: 'button'
        },

        edit: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'editPasarela',
          tooltip: this.$t('mEditionBillingPaymentMethods.tooltip.edit'),
          type: 'button'
        },

        data: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionBillingPaymentMethodsModalConfigurationData',
          icon: 'fas fa-clipboard-list',
          method: 'showModal',
          tooltip: this.$t('mEditionBillingPaymentMethods.tooltip.data'),
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      pasarelas: [],

      requests: {
        updateAcademiaPasarelaEstado: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: 0
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState--
      this.readAcademiaPasarelasConfiguradas()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readPasarelas()
  },

  methods: {
    getPasarelaNombre (pasarelaId) {
      return this.pasarelas.find(pasarela => pasarela.id === pasarelaId).nombre
    },

    editPasarela (pasarela) {
      pasarela.nombre = this.getPasarelaNombre(pasarela.pasarela_pago)
      this.$store.commit('setBillingPaymentMethodEdit', pasarela)
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}/${this.$t('mEditionMenu.billing.paymentMethods.children.editMethod.subedition')}`)
    },

    readAcademiaPasarelasConfiguradas () {
      this.$services.read('academia', 'readAcademiaPasarelasConfiguradas', {}, [this.academiaId, 0])
        .then(response => {
          this.academiaPasarelasConfiguradas = response.data
          this.academiaPasarelasConfiguradas.forEach(pasarelaConfigurada => {
            pasarelaConfigurada.imagen = this.pasarelas.find(pasarela => pasarela.id === pasarelaConfigurada.pasarela_pago).imagen
            pasarelaConfigurada.manual = this.pasarelas.find(pasarela => pasarela.id === pasarelaConfigurada.pasarela_pago).manual
          })
          this.pagination.currentQuantity = this.academiaPasarelasConfiguradas.length
          this.pagination.totalQuantity = this.academiaPasarelasConfiguradas.length
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readPasarelas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.readAcademiaPasarelasConfiguradas()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    selectPasarela (pasarela) {
      this.$store.commit('setBillingPaymentMethod', pasarela)
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}/${this.$t('mEditionMenu.billing.paymentMethods.children.connectMethod.subedition')}`)
    },

    updateAcademiaPasarelaEstado (element) {
      if (!this.requests.updateAcademiaPasarelaEstado.isRequested) {
        this.requests.updateAcademiaPasarelaEstado.isRequested = true
        this.requests.updateAcademiaPasarelaEstado.itemLoading = element.id
        this.$services.update('academia', 'updateAcademiaPasarelaEstado', { estado: element.state }, [this.academiaId, element.id])
          .then(response => {
            this.readAcademiaPasarelasConfiguradas()
            this.$alerts.pushAlert('mEditionBillingPaymentMethods', 'updateAcademiaPasarelaEstado', response.data.activa ? 'activationSuccess' : 'deactivationSuccess')
            this.requests.updateAcademiaPasarelaEstado.isRequested = false
          })
          .catch(error => {
            console.log(error)
            if (error.response.data.error.message === 'Academia Pasarela Pago activa en gestiones') {
              this.$modal.showModal('MoleculeEditionBillingPaymentMethodsModalActionDisabled')
              this.academiaPasarelasConfiguradas.find(pasarela => pasarela.id_academia_pasarela_pago === element.id).activa = true
            } else {
              this.$alerts.pushAlert('mEditionBillingPaymentMethods', 'updateAcademiaPasarelaEstado', 'error', 'a-alert-danger')
            }
            this.requests.updateAcademiaPasarelaEstado.isRequested = false
          })
      }
    }
  }
}
</script>
